import { tabletMax } from '@propertypal/shared/src/constants/mediaQueries';
import styled from 'styled-components';
import { Body, Header } from '../layout/InfoBox.style';

export const MapWrapper = styled.div`
  border-radius: 10px;
  border: 2px solid ${({ theme }) => theme.keyline};
  overflow: hidden;
  margin: 10px 0;
`;

export const Row = styled.div`
  display: flex;
  gap: 15px;
  margin: 10px 0;

  ${Header} {
    font-size: 18px;
  }

  & > div {
    flex: 1;
  }

  @media (${tabletMax}) {
    flex-direction: column;
  }

  ${Body} {
    display: flex;
    flex-direction: column;
    justify-content: space-between;
  }
`;
